import React, { useState, useEffect } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import FiltersPartial from './FiltersPartial.js';
import { faEye, faEdit } from "@fortawesome/free-solid-svg-icons";
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import SimpleTableComponent from '../../components/SimpleTableComponent'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from 'react-router-dom'
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import env from "react-dotenv";
import FinalizeModal from './FinalizeModal'
import PaymentModal from './PaymentModal'

const Index = (props) => {
  const [filtersModel, setFiltersModel] = useState({});
  const defaultHeaderConfig = { disableSort: false };
  const [toUpdateRow, setToUpdateRow] = useState(null);
  const navigate = useNavigate(); 

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Bill For',
      value: (row) => {
        return <div className='d-block'>
          <div>
            (CP{row.user_id}) {row.user_name}
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Month For',
      attr: 'end_of_month',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Total Amount',
      attr: 'amount'
    },
    {
      ...defaultHeaderConfig,
      label: 'Unpaid Amount',
      attr: 'unpaid_amount'
    },
    {
      ...defaultHeaderConfig,
      label: 'Bill Generated',
      value: (row) => {
        const val = row.bill_generated
        if (val) {
          return <div>Yes</div>
        }
        else {
          return <div>No</div>
        }
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      value: (row) => {
        let fontColor = row.status_font_color
        return <div style={{ color: `${fontColor}`}}>{row.status.toUpperCase()} {row.tally_transaction_number}</div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Bill',
      value: (row) => {
        return <div className='d-flex justify-content-between'>
          {row.bill_no}
          {row.bill_no && <a href={`${env.API_HOST}/api/v2/partner_billings/${row.id}/bill_pdf.pdf`} target="_blank"><FontAwesomeIcon icon={faDownload} /></a>}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_partner_billing.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>

          {/*<UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_partner_billing.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row)}>
              <FontAwesomeIcon icon={row.is_editable? faEdit : faEye} />
            </div>
          </UiAction>*/}
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_partner_billing_status_update.name)}>
            {row.status == "unpaid" && <div onClick={(e)=>setToUpdateRow(row)} style={{ cursor: 'pointer' }}>
                <button className='border'>finalize bill</button>
              </div>}

              {(row.status == "partially_paid" || row.status == "processing") && <div onClick={(e)=>setToUpdateRow(row)} style={{ cursor: 'pointer' }}>
                <button className='border'>Payment</button>
              </div>}
          </UiAction>
        </div>
          
      },
      disableSort: true
    },
  ]

  const onViewClick = (row) => {
    navigate(`/partner_billings/${row.id}`)
  }

  return <>
  { toUpdateRow?.status == "unpaid" ? 
    <FinalizeModal updateDetails={toUpdateRow} updateShowState={() => setToUpdateRow(null)}/> 
    : <PaymentModal updateDetails={toUpdateRow} updateShowState={() => setToUpdateRow(null)}/>
  }
  <ListingPageComponent
    key={PAGES.PartnerBillingsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.PartnerBillingsListingPage.name)}
    breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Partner Billings' }]}
    listingMutation={getApi('partner_billings')}
    className="partner-billings-listing-page"
    contentHeading="Partner Billings List - Results"
    headers={headers}
    recordsKey="partner_billings"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID', 'Bill User ID', 'Bill User Name', 'Bill No.']}
  />
  </>
}

export default Index;
